var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCombine = function SvgCombine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 .7c-1 0-1.9.9-1.9 1.9V8l-6.5 6.5L10 8V2.6c0-1-.9-1.9-1.9-1.9s-1.8.9-1.8 1.9v6.1c0 .4.1 1 .6 1.3l7.9 7.9v6.8l-1.5-1.5c-.7-.7-1.9-.7-2.7 0-.7.7-.7 1.9 0 2.7l4.8 4.8c.3.3.9.6 1.3.6s.9-.1 1.3-.6l4.8-4.8c.7-.7.7-1.9 0-2.7-.7-.7-1.9-.7-2.7 0l-1.5 1.5v-6.8l7.7-7.9c.3-.3.6-.9.6-1.3V2.6c-.1-1-.9-1.9-1.9-1.9"
  })));
};
export default SvgCombine;